<template>
    <a
        class="base-card"
        :href="post.link"
        :target="linkTarget"
        :class="{ 'base-card--show': visible }"
    >
        <figure class="base-card__figure">
            <img
                v-if="imageSrc"
                class="base-card__image"
                :src="imageSrc"
                :srcset="imageSrcSet"
                :sizes="sizes"
            >
            <div
                class="label-reference"
                :data-image-reference="imageReference"
            />
            <div
                v-if="label"
                class="base-card__label-type"
            >{{ label }}
            </div>
        </figure>

        <h2
            v-if="post.title.rendered"
            class="base-card__title"
            v-html="post.title.rendered"
        />

        <div
            v-if="post.excerpt.rendered"
            class="base-card__copy"
            v-html="post.excerpt.rendered"
        />

    </a>
</template>

<script>
import BaseCard from './BaseCard.vue'
import { getSizesStringByColumns } from '@bahn-wordpress/common/src/js/admin/utils/source-set'

export default {
    name: 'CardPage',
    extends: BaseCard,

    props: {
        post: {
            type: Object,
            default(){
                return {}
            },
        },
        label: {
            type: String,
            default: '',
        },
    },
    data(){
        return {
            linkTarget: '_self',
        }
    },

    computed: {
        image(){
            return this.post.dbec_featured_media || {}
        },
        imageSrc(){
            return this.image.source_url
        },
        imageSrcSet(){
            return this.image.source_set
        },
        imageReference(){
            return this.image.caption
        },
        sizes(){
            return getSizesStringByColumns({ small: 6, medium: 3, large: 2 })
        },
    },

    methods: {},
}
</script>
